<div *ngIf="shouldShowErrors()" class="field__item--error">
  <span *ngFor="let error of listOfErrors()">
    {{ error }}
  </span>
</div>
